import styled from 'styled-components'

export const GridTemplate = styled.section`
  margin-left: auto;
  margin-right: auto;
  max-width: 65rem;
`
